import makeStyles from '@mui/styles/makeStyles'
import bgImage from './mindset-agent-preview.png'
import { appBarHeight } from '../app-toolbar-consumer/style'
import { paidConsumerDesktopNavHeight, paidConsumerMobileNavHeight } from '../app-toolbar-paid-consumer/style'
import { trialBannerHeight } from '../app-toolbar-paid-consumer/navigation/style'

export const useStyles = makeStyles(({ breakpoints, typography, palette }) => ({
  root: {
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      height: ({ isPaidConsumer, isMobile, isTrialBannerVisible }) => {
        const navHeight = isPaidConsumer ? (isMobile ? paidConsumerMobileNavHeight : paidConsumerDesktopNavHeight) : appBarHeight
        const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
        return `calc(100% - ${totalHeight}px)`
      },
      top: ({ isPaidConsumer, isMobile, isTrialBannerVisible }) => {
        const navHeight = isPaidConsumer ? (isMobile ? paidConsumerMobileNavHeight : paidConsumerDesktopNavHeight) : appBarHeight
        const totalHeight = isTrialBannerVisible ? navHeight + trialBannerHeight : navHeight
        return `${totalHeight}px`
      },
      width: '100%',
      overflow: 'hidden',
      boxSizing: 'border-box',
      [breakpoints.up('sm')]: {
        width: 400
      },
      [breakpoints.up('md')]: {
        width: 550
      },
      [breakpoints.up('lg')]: {
        width: 700
      }
    }
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '16px',
    paddingBottom: '32px'
  },
  close: {
    zIndex: 3,
    position: 'absolute',
    top: '16px',
    right: '16px'
  },
  background: {
    position: 'relative',
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    filter: 'blur(7px)',
    height: '100%',
    width: '100%'
  },
  ctaContainer: {
    position: 'absolute',
    zIndex: 2,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    textAlign: 'center',
    height: '100%'
  },
  ctaContent: {
    backgroundColor: 'white',
    padding: '2rem',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '400px',
    width: '100%'
  },
  message: {
    marginTop: '0.5rem',
    fontWeight: 500,
    ...typography.heading.h5
  },
  joinMessage: {
    marginTop: '1rem'
  },
  goToSignMessage: {
    marginTop: '0.5rem'
  }
}))
